import ComplaintType from "./complaint.types";

const initialState = {
  comtelData: {
    id: "OUI",
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    company: "COMTEL Technologies",

  },
  errorComtelData: null,
  complaint: null,
  errorComplaint: null,
};

export default function complaintReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case ComplaintType.COMPLAINT_SUCCESS:
      return {
        ...state,
        complaint: payload,
      };
    case ComplaintType.COMPLAINT_FAILURE:
      return {
        ...state,
        errorComplaint: payload,
      };
    case ComplaintType.COMPLAINT_CONFIG_SUCCESS:
      return {
        ...state,
        comtelData: {
          id: payload.id,
          firstname: payload.firstname,
          lastname: payload.lastname,
          email: payload.email,
          phone: payload.phone,
          company: payload.company,
          current: payload.current,
        },
      };
    case ComplaintType.COMPLAINT_CONFIG_FAILURE:
      return {
        ...state,
        errorComtelData: payload,
      };
    default:
      return state;
  }
}
